export enum ContextMenuEntryType {
  Audit = 'audit',
  BulkImport = 'bulkimport',
  Claim = 'claim',
  EditDSO = 'editdso',
  EditRelationships = 'editrelationships',
  EditSubmission = 'editsubmission',
  ExportCollection = 'exportcollection',
  ExportItem = 'exportitem',
  RequestCorrection = 'requestcorrection',
  Statistics = 'statistics',
  Subscriptions = 'subscriptions',
  Report = 'report',
  ItemVersion = 'itemversion',
  FullItem = 'fullitem',
  OrcidView = 'orcidview',
}
